import { render, staticRenderFns } from "./CRMcontent.vue?vue&type=template&id=2d83a52c&scoped=true&"
import script from "./CRMcontent.vue?vue&type=script&lang=js&"
export * from "./CRMcontent.vue?vue&type=script&lang=js&"
import style0 from "./CRMcontent.vue?vue&type=style&index=0&id=2d83a52c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d83a52c",
  null
  
)

export default component.exports